import { Popconfirm } from 'antd';
import React from 'react';
import { FaEye, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import Button from '~/components/Button';
import Can from '~/components/Can';
import { TableActions } from '~/components/Table';
import moment from 'moment';
import 'moment/locale/pt-br';
import Strong from '~/components/Strong';
import i18next from 'i18next';
import { formatPrice } from '~/Utils/format';

export const extraRevenuesColumns = (handleEdit, handleDelete, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('screens:Nome')}:</Strong> {record.name}
            <br />
            <Strong>{i18next.t('screens:Data')}:</Strong>{' '}
            {moment(record.acquired_at).locale('pt-br').format('DD/MM/YYYY')}
            <br />
            <Strong>{i18next.t('screens:Valor')}:</Strong>{' '}
            {Number(record.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            <br />
            <TableActions align="center" justify="center" isMobile={isMobile}>
              <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
                <FaEye />
              </Button>
              <Can permission="@extras/edit">
                <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
                  <FaPencilAlt />
                </Button>
              </Can>
              <Can permission="@extras/delete">
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:yes')}
                  onConfirm={() => handleDelete(record.id)}
                  cancelText={i18next.t('messages:no')}
                >
                  <Button size="small" title="Excluir">
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:Nome'),
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => record.name,
    },
    {
      title: i18next.t('screens:Data'),
      dataIndex: 'acquired_at',
      key: 'acquired_at',
      render: (_, record) => moment(record.acquired_at).locale('pt-br').format('DD/MM/YYYY'), //formatar data
    },
    {
      title: i18next.t('screens:Valor'),
      dataIndex: 'price',
      key: 'price',
      width: '300px',
      render: (_, record) => formatPrice(record?.price, false),
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (_, record) => (
        <TableActions align="center" justify="center">
          <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
            <FaEye />
          </Button>
          <Can permission="@extras/edit">
            <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Can permission="@extras/delete">
            <Popconfirm
              title={i18next.t('messages:confirmDelete')}
              okText={i18next.t('messages:yes')}
              onConfirm={() => handleDelete(record.id)}
              cancelText={i18next.t('messages:no')}
            >
              <Button size="small" title="Excluir">
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          </Can>
        </TableActions>
      ),
    },
  ];
};
